var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.color,
        viewBox: "0 0 32 24",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0,7v13c0,2.21,1.79,4,4,4h24c2.21,0,4-1.79,4-4V7l-13.6,10.2c-1.43,1.07-3.38,1.07-4.8,0L0,7ZM3,0C1.34,0,0,1.34,0,3c0,.94.44,1.83,1.2,2.4l13.6,10.2c.71.53,1.69.53,2.4,0l13.6-10.2c.76-.57,1.2-1.46,1.2-2.4,0-1.66-1.34-3-3-3H3Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }